/* eslint-disable max-lines-per-function */
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { validacoesFormDesconto } from './helpers/yupValidations';
import CurrencyTextField from '../../modulos/mascaraMoeda/CurrencyTextField';
import ValorFinalDesconto from './ValorFinalDesconto.jsx';

export default function BodyModalEditMensalidade({ infoModal, onSubmit, classes }) {
    return <div className="ModalStyle PaperModal1">
        <Typography variant="h6" gutterBottom>
            Edição de Preço de Mensalidade
        </Typography>
        <div className="dentroModalEdicao">
            {infoModal && (
                <>
                    <Formik onSubmit={onSubmit} validateOnMount={true} validateOnBlur={true} validationSchema={validacoesFormDesconto} initialValues={{ 
                        valorBase: infoModal.valorBase,
                        valorFinal: '',
                        formasPagamento: '',
                        dataFinalDesconto: '',
                        dataInicioDesconto: '' }}>
                        {({ handleChange, setFieldValue, onSubmit, values }) => <>
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Valor Base"
                                            id="valorBase"
                                            name="valorBase"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={handleChange}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                            defaultValue={infoModal.valorBase}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="valorBase"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            as={TextField}
                                            id="dataInicioDesconto"
                                            label="Data inicio desconto"
                                            name="dataInicioDesconto"
                                            type="date"
                                            style={{ width: '100%' }}

                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            onChange={handleChange}
                                            value={values.dataInicioDesconto}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="dataInicioDesconto"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            as={TextField}
                                            id="dataFinalDesconto"
                                            label="Data final desconto"
                                            name="dataFinalDesconto"
                                            style={{ width: '100%' }}

                                            type="date"
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            onChange={handleChange}
                                            value={values.dataFinalDesconto}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="dataFinalDesconto"
                                            style={{ color: 'red' }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Valor do desconto"
                                            id="valorDesconto"
                                            name="valorDesconto"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={handleChange}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                            defaultValue={infoModal.valorComDesconto ?? '' }
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="valorDesconto"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormGroup 
                                            row={true}>
                                            <FormControlLabel 
                                                control={<Checkbox  color='primary' />} 
                                                label="Cartão " 
                                                value={values.pagamentoCartao}
                                                id='pagamentoCartao'
                                                name='pagamentoCartao'
                                                onChange={handleChange}/>
                                            <FormControlLabel 
                                                control={<Checkbox color='primary'/>} 
                                                label="Boleto" 
                                                value={values.PagamentoBoleto}
                                                id='pagamentoBoleto'
                                                name='pagamentoBoleto'
                                                onChange={handleChange}/>
                                            {infoModal.UF ==='ES' && <> 
                                                <FormControlLabel 
                                                    control={<Checkbox color='primary'/>} 
                                                    label="Escelsa" 
                                                    value={values.pagamentoEscelsa} 
                                                    id='pagamentoEscelsa'
                                                    name='pagamentoEscelsa'
                                                    onChange={handleChange}/>
                                            </>}
                                        </FormGroup>
                                        <ErrorMessage
                                            component="span"
                                            name="formasPagamento"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <ValorFinalDesconto/>
                                    </Grid>
                                </Grid>
                                <Button
                                    className={classes.buttons}
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => setFieldValue(onSubmit)}
                                >
                                        Salvar
                                </Button>
                            </Form>
                        </>}
                    </Formik>
                </>
            )}
        </div>
    </div>;
}
